export default () => ({
  location: null,
  locations: [],
  changed: null
})
